import { ImageFileIcon, ImageFileIconProps } from "../ImageFileIcon"

export const SatelliteMapIcon = ({ containerClasses, iconSize }: ImageFileIconProps) => {
    return (
        <ImageFileIcon
            id="Satellite-map-icon"
            imageFilePath="/images/maps/satellite.jpg"
            containerClasses={containerClasses}
            iconSize={iconSize}
        />
    )
}

export default SatelliteMapIcon
